export enum MaintenanceScopeOptions {
	MAJOR_SERVICE = "MAJOR_SERVICE",
	MINOR_SERVICE = "MINOR_SERVICE",
	NO_SELECTION = "NO_SELECTION",
}

export const isMaintenanceScopeOption = (value: unknown): value is MaintenanceScopeOptions => {
	return (
		value === MaintenanceScopeOptions.MAJOR_SERVICE ||
		value === MaintenanceScopeOptions.MINOR_SERVICE ||
		value === MaintenanceScopeOptions.NO_SELECTION
	)
}
